import { SettingCard, SettingCardRow } from '@components/Dashboard/components'
import { AngleRight } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import css from './styles.module.css'

interface Props {
  onClick: () => void
}

export const PlanCard: React.FC<Props> = ({ onClick }) => {
  return (
    <SettingCard title="Plan overview">
      <SettingCardRow
        title="Team plan"
        description="This is your personal subscription plan."
      >
        <button className={css.plan_button} onClick={onClick}>
          Switch plan <AngleRight />
        </button>
      </SettingCardRow>
    </SettingCard>
  )
}
